import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function IOT_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. Study about Microcontrollers and their uses in Arduino using the Arduino IDE tool.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is a Microcontroller, Architecture of Microcontroller, How is Microcontroller different from Microprocessor, ATMEGA 328p.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. Learn about virtual platforms, build your circuits and gain skills in coding the Arduino board.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is Arduino, Architecture of Arduino, Virtual simulator for Arduino, Working with Arduino ID, Programming an Arduino using C++, Arduino Code Implementation, Mini project discussion.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. Enhance the communication between device and microcontroller</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          12C, SPI, BLUETOOTH, Zigbee/Rfd, Bluetooth/Nfc, Wifi, Protocols-TCP, UDP, MQTT/MQTTS, HTTP/HTTPS.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. Make use of Thing speak api and learns how to integrate different apps by developing your own skills.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Weather Reporting System, Social distancing alarm system, Smart parking system, Home automation, Password door lock system, IFTTT App • Sending notification using various applications, Smart agriculture system, Remote control robotic system. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Dive deep into developing IOT technology and it’s wireless protocols standards</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is IOT, What are the challenges and future of IOT, IOT Architecture, Introduction to Sensors, Esp8266 Wifi Module, Connection using HTTP, Rules for React, Using Matlab for Analysis.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
      {/* <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. Design methodology and tools</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Design Methodology ( Design Thinking, Agile Development, Waterfall Model ), Design Tools (Computer-Aided Design (CAD) Software, Electronic Design Automation (EDA) Tools, Simulation and Modeling Software ) 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
}
